module.exports = __webpack_public_path__ + "img/finland-stomach-cancer-male.b88435a9.png";